import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { withJwt } from '../../../utils/with-jwt';
import { selectData } from '../../../utils/select-data';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { AuthHeaders } from '../../../models/auth-headers';
import { AddOn } from '../schemas/add-on';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Remove the same product license from multiple Users
 * @param productId ID of the product to assign
 * @param externalIds Array of User External IDs
 * @returns A data object indicating success
 */
export function deleteLicenseProductIdBulk(
  this: unknown,
  productId: number,
  externalIds: { externalId: string }[],
  addons?: AddOn[]
) {
  let url = accountsEnvironment.resolve(this).licenseBulkUrl(productId);
  if (addons && addons.length >= 1) {
    url += `?${addons.map((addon) => `addons=${addon}`).join('&')}`;
  }
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(url, {
        method: 'DELETE',
        headers: {
          ...requiredHeaders,
          ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
            ? new AuthHeaders()
            : jwtAuthHeaders),
        },
        body: JSON.stringify(externalIds),
      })
    )
  ).pipe(
    selectData(
      z.object({
        success: z.boolean(),
      })
    )
  );
}
